// extracted by mini-css-extract-plugin
export default {"container":"styles_container__39G53","table_head":"styles_table_head__nytlD","table_head_cell":"styles_table_head_cell__dKV0J","table_body_row":"styles_table_body_row__+4qZ-"};